const DAYS_MAP = {
  sunday: 0,
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6,
};

/**
 * Calculates day offset relative to today (0 = today, 1 = tomorrow, 2..6 = future weekdays)
 * @param {string} dayKey
 * @returns {number}
 */
export function getDayOffset(dayKey) {
  const lower = String(dayKey || '')
    .trim()
    .toLowerCase();
  if (lower === 'today') return 0;
  if (lower === 'tomorrow') return 1;
  const targetDayNum = DAYS_MAP[lower];
  if (targetDayNum !== undefined) {
    const currentDayNum = new Date().getDay();
    const diff = (targetDayNum - currentDayNum + 7) % 7;
    return diff === 0 ? 7 : diff;
  }
  return 99;
}

/**
 * Checks if a delivery slot for a given dayKey has already completed based on current time
 * @param {string} dayKey
 * @param {{ end_time?: string, endTime?: string }} slot
 * @returns {boolean}
 */
export function isSlotCompleted(dayKey, slot) {
  const offset = getDayOffset(dayKey);
  if (offset !== 0) return false;

  const endTimeStr = slot?.end_time || slot?.endTime;
  if (!endTimeStr) return false;

  const [hStr, mStr = '0'] = String(endTimeStr).split(':');
  const slotEndMinutes = (parseInt(hStr, 10) || 0) * 60 + (parseInt(mStr, 10) || 0);

  const now = new Date();
  const currentMinutes = now.getHours() * 60 + now.getMinutes();

  return slotEndMinutes <= currentMinutes;
}

/**
 * Formats a day key into a user-friendly title displaying the actual day name
 * @param {string} dayKey
 * @returns {string}
 */
export function formatSlotDayLabel(dayKey) {
  if (!dayKey) return '';
  const trimmed = String(dayKey).trim();
  return trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
}

/**
 * Computes YYYY-MM-DD date string for a given dayKey/slot
 * @param {string} [dayKey]
 * @param {{ date?: string, delivery_date?: string }} [slot]
 * @returns {string}
 */
export function computeSlotDate(dayKey, slot) {
  if (slot?.date || slot?.delivery_date) return slot.date || slot.delivery_date;
  const offset = getDayOffset(dayKey);
  const d = new Date();
  d.setDate(d.getDate() + (offset === 99 ? 0 : offset));
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}
